// LEGAL STATUS: To be legally validated before commercial production (EN translation of fr/CommercialTermsPage.js).
import { Link } from "react-router-dom";
import { Page, H1, H2, Lead, P, Notice, Toc, DocVersion } from "../../public/primitives";
import { legal } from "../../../config/legal";

// "To be finalised before commercial activation" — no future pricing rule is invented.
const TBD = () => (
  <span data-testid="commercial-tbd" className="text-amber-600 italic font-medium">
    To be finalised before commercial activation
  </span>
);

export const CommercialTermsPage = () => (
  <Page testid="commercial-terms-page">
    <H1>Commercial terms</H1>
    <Lead>
      Structure of the SecurePass commercial terms. Version <DocVersion value={legal.commercialTermsVersion} />.
      The final rules will be set before payment is activated.
    </Lead>

    <Toc
      items={[
        { id: "offres", label: "Plans" },
        { id: "prix", label: "Prices" },
        { id: "utilisateurs-supplementaires", label: "Additional users" },
        { id: "facturation", label: "Billing" },
        { id: "renouvellement", label: "Renewal" },
        { id: "changement", label: "Plan change" },
        { id: "resiliation", label: "Cancellation" },
        { id: "paiement", label: "Payment" },
        { id: "taxes", label: "Taxes" },
        { id: "factures", label: "Invoices" },
        { id: "enterprise", label: "Enterprise / quote-based" },
      ]}
    />

    <H2 id="offres">Plans</H2>
    <P>
      SecurePass offers several plans (see the
      <Link to="/offres" className="text-emerald-600 underline"> Plans</Link> page). Detailed terms per
      plan: <TBD />.
    </P>

    <H2 id="prix">Prices</H2>
    <P>Final pricing terms and conditions: <TBD />.</P>

    <H2 id="utilisateurs-supplementaires">Additional users</H2>
    <P>Billing rules for additional users: <TBD />.</P>

    <H2 id="facturation">Billing</H2>
    <P>Billing cycle and terms: <TBD />.</P>

    <H2 id="renouvellement">Renewal</H2>
    <P>Subscription renewal terms: <TBD />.</P>

    <H2 id="changement">Plan change</H2>
    <P>Terms for switching from one plan to another: <TBD />.</P>

    <H2 id="resiliation">Cancellation</H2>
    <P>Terms and effects of cancellation: <TBD />.</P>

    <H2 id="paiement">Payment</H2>
    <P>Payment methods and terms: <TBD />.</P>

    <H2 id="taxes">Taxes</H2>
    <P>Treatment of applicable taxes: <TBD />.</P>

    <H2 id="factures">Invoices</H2>
    <P>Issuing and provision of invoices: <TBD />.</P>

    <H2 id="enterprise">Enterprise / quote-based plans</H2>
    <P>Terms of quote-based plans: <TBD />.</P>

    <Notice testid="commercial-work-note">
      This page prepares the structure; the commercial rules are not yet defined and will not be
      invented. Payment is not activated.
    </Notice>
  </Page>
);

export default CommercialTermsPage;
